<template>
    <Link :href="href" :method="method" as="button" type="button" class="inline-block appearance-none select-none py-[18px] px-14 text-xs font-normal text-center text-white bg-pink-900 cursor-pointer hover:shadow-sm hover:scale-105 transition-transform ease-in-out hover:text-white rounded-full">
        <slot />
    </Link>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

export default {
    components: {
        Link,
    },
    props: {
        href: {
            type: String,
            default: 'submit',
        },
        method: {
            type: String,
            default: 'get',
        },
    }
}
</script>
